import { Dayjs } from '@mst-fe/shared/dayjs';

import { PreciseTime } from '../_shared/views/preciseTimePicker/PreciseTime';
import { coerceDateTime } from '../midas/utils/config-utils';

export const coerceDateTimesToDatesTimes = (value?: { date: Dayjs; startTime?: PreciseTime; endTime?: PreciseTime }) => {
  const { date, startTime, endTime } = value ?? {};

  if (!date || !startTime || !endTime) {
    return {};
  }

  return { startDate: coerceDateTime(date, startTime), endDate: coerceDateTime(date, endTime) };
};
